import React, { Component } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import SmsTemplates from '../orgnizationMaster/configuration/smsTemplates/smsTemplatesList';
import WhatsappTemplates from '../orgnizationMaster/configuration/whatsAppTemplates/whatsAppTemplatesList';
import EmailTemplates from '../orgnizationMaster/configuration/emailTemplates/emailTemplatesList';
import PushNotificationTemplates from '../orgnizationMaster/configuration/pushNotificationTemplates/pushNotificationTemplatesList';
import './templateManagement.css'; // Optional CSS file for custom styling
import { connect } from 'react-redux';
import Authentication from '../session';
import withRouter from '../lib/withRouter';

class TemplateManagement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeIndex: 0
        };
    }

    render() {
        return (
            <div className="template-management-container p-4">
                <TabView
                    activeIndex={this.state.activeIndex}
                    onTabChange={(e) => this.setState({ activeIndex: e.index })}
                    className="template-tabs"
                >
                    <TabPanel
                        header="SMS"
                        className="sms-templates-tab"
                    >
                        <div className="tab-content p-3">
                            <SmsTemplates orgId={this.props.orgData?.orgId} />
                        </div>
                    </TabPanel>

                    <TabPanel
                        header="WhatsApp"
                        className="whatsapp-templates-tab"
                    >
                        <div className="tab-content p-3">
                            <WhatsappTemplates />
                        </div>
                    </TabPanel>

                    <TabPanel
                        header="Email"
                        className="email-templates-tab"
                    >
                        <div className="tab-content p-3">
                            <EmailTemplates orgId={this.props.orgData?.orgId} />
                        </div>
                    </TabPanel>

                    <TabPanel
                        header="Push Notifications"
                        className="push-notification-templates-tab"
                    >
                        <div className="tab-content p-3">
                            <PushNotificationTemplates orgId={this.props.orgData?.orgId} />
                        </div>
                    </TabPanel>
                </TabView>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    orgData: state.orgData
});

export default connect(mapStateToProps)(Authentication(withRouter(TemplateManagement)));